import axios from 'axios';
import { getApiUrl } from '../config/environment';
import {
  normalizeAgendaVisibleWeekdays,
  readCachedAgendaVisibleWeekdays,
  writeCachedAgendaVisibleWeekdays,
} from './agendaVisibleWeekdays';

export type AgendaClinicSettingsPayload = Record<string, unknown>;

const inflightByUnit = new Map<string, Promise<AgendaClinicSettingsPayload | null>>();

function fetchAndCache(unitId: string): Promise<AgendaClinicSettingsPayload | null> {
  return axios
    .get(getApiUrl('/clinic/settings'))
    .then((res) => {
      const data = (res.data?.data ?? null) as AgendaClinicSettingsPayload | null;
      if (data) {
        writeCachedAgendaVisibleWeekdays(
          unitId,
          normalizeAgendaVisibleWeekdays(data.agenda_visible_weekdays),
        );
      }
      return data;
    })
    .catch(() => null);
}

/** Dispara GET /clinic/settings cedo (layout / idle) para a Agenda não esperar só no mount. */
export function prefetchAgendaClinicSettings(unitId: string): void {
  if (!unitId || typeof window === 'undefined') return;
  if (!inflightByUnit.has(unitId)) {
    inflightByUnit.set(unitId, fetchAndCache(unitId));
  }
}

/** Mesma promessa do prefetch, ou inicia agora se ainda não existir. */
export function loadAgendaClinicSettings(unitId: string): Promise<AgendaClinicSettingsPayload | null> {
  if (!unitId) return Promise.resolve(null);
  if (!inflightByUnit.has(unitId)) {
    inflightByUnit.set(unitId, fetchAndCache(unitId));
  }
  return inflightByUnit.get(unitId)!;
}

export function hasCachedAgendaVisibleWeekdaysForUnit(unitId: string): boolean {
  return readCachedAgendaVisibleWeekdays(unitId) != null;
}
